export class WorkflowStateCountData {
    public workflowStateId: number;
    public workflowStateName: string;

    public formInstanceCount: number; // The count of form instances in this state.
    public folderCount: number; // The count of folders in this state.
}
